import { createSelector } from "reselect";

const getOffDutyUsersState = (state) => state.users.offDuty;

export const getSelectedOffDutyUsersDate = createSelector([ getOffDutyUsersState ], ({ selectedDate }) => selectedDate);